import React from "react";
import { Layout } from "antd";
const { Footer } = Layout;

const FooterComp = () => {
  return (
    <Footer style={{ textAlign: "center" }}>
      Created with &hearts; by Raju
    </Footer>
  );
};

export default FooterComp;
